export const PAYMENT_LINK_BANNER_ID = 'PAYMENT_LINK_BANNER_ID';
export const CREATED_INVOICE_BANNER_ID = 'CREATED_INVOICE_BANNER_ID';
export const MINIMAL_PAYMENT = 990;
export const DAYS_TO_SHOW_BANNER = 30;
